import Vuex from "vuex";

export const stateMixin = {
    computed: {
        ...Vuex.mapGetters({
            getMode: "plano/status/getMode",
            getModulesEdit: "plano/status/getModulesEdit",
            getMeuble: "plano/data/getMeuble",
            getRelatedProducts: "plano/data/getRelatedProducts",
            // getSelectModules: 'plano/status/getSelectModules',
            // countSelectModules: 'plano/status/countSelectModules',
            // getGroupSelected: 'plano/status/getGroupSelected',
            getPositionModule: "plano/status/getPositionModule",
            // getAccessories: 'plano/status/getAccessories',
            // getAccessoriesSelected: 'plano/status/getAccessoriesSelected',
            hasUpdatePlano: "plano/status/hasUpdatePlano",
            canDisplayMenuShades: "plano/status/canDisplayMenuShades",
            canDisplayMenuTicketStrip: "plano/status/canDisplayMenuTicketStrip",
            canDisplayMenuScratch: "plano/status/canDisplayMenuScratch",
            canDisplayMenuFavorite: "plano/status/canDisplayMenuFavorite",
            canDisplayMenuLibrary: "plano/status/canDisplayMenuLibrary",
            canDisplayComments: "plano/status/canDisplayComments",
            canDisplayExports: "plano/status/canDisplayExports",
            canModeSave: "plano/status/canModeSave",
            showModalFavorite: "plano/status/showModalFavorite",
            getViewsActive: "plano/status/getViewsActive",
            getPlanoDetails: "plano/data/getPlanoDetails",
            getCommentsStatus: "plano/data/getCommentsStatus",
            getLocale: "i18n/getLocale",
            getTicketStripClone: "plano/status/getTicketStripClone",
            isNewPlano: "plano/data/isNewPlano",
            isNext: "plano/data/isNext"
        })
    },
    methods: {
        ...Vuex.mapActions({
            setModeSave: "plano/status/setModeSave",
            setMode: "plano/status/setMode",
            setUpdatePlano: "plano/status/setUpdatePlano",
            // addSelectModule: 'plano/status/addSelectModule',
            // deleteSelectModule: 'plano/status/deleteSelectModule',
            // deleteAllModules: 'plano/status/deleteAllModules',
            // deleteAllModulesElt: 'plano/status/deleteAllModulesElt',
            // setGroupSelected: 'plano/status/setGroupSelected',
            // saveGroup: 'plano/status/saveGroup',
            setModulesEdit: "plano/status/setModulesEdit",
            deleteScratchModule: "plano/status/deleteScratchModule",
            addScratchPad: "plano/status/addScratchPad",
            addFavorite: "plano/status/addFavorite",
            // addAccessory: 'plano/status/addAccessory',
            // deleteAccessory: 'plano/status/deleteAccessory',
            // addAccessorySelected: 'plano/status/addAccessorySelected',
            // deleteAccessorySelected: 'plano/status/deleteAccessorySelected',
            getDetails: "items/getDetails",
            getMeubleAction: "plano/data/getMeuble",
            cleanMeuble: "plano/data/cleanMeuble",
            saveCommentsStatus: "plano/data/saveCommentsStatus",
            getRelatedProductsAction: "plano/data/getRelatedProducts",
            setDisplayMenuShades: "plano/status/setDisplayMenuShades",
            setDisplayMenuTicketStrip: "plano/status/setDisplayMenuTicketStrip",
            setDisplayMenuScratch: "plano/status/setDisplayMenuScratch",
            setDisplayMenuFavorite: "plano/status/setDisplayMenuFavorite",
            setDisplayMenuLibrary: "plano/status/setDisplayMenuLibrary",
            setDisplayComments: "plano/status/setDisplayComments",
            setDisplayExports: "plano/status/setDisplayExports",
            setShowModalFavorite: "plano/status/setShowModalFavorite",
            addViewActive: "plano/status/addViewActive",
            removeViewActive: "plano/status/removeViewActive",
            setTicketStripToClone: "plano/status/setTicketStripToClone"
        })
    }
};



// WEBPACK FOOTER //
// ./src/components/plano/mixins/state.js